import { render, staticRenderFns } from "./NotificationSubscriptions.vue?vue&type=template&id=32ccf33e&scoped=true&"
import script from "./NotificationSubscriptions.vue?vue&type=script&lang=js&"
export * from "./NotificationSubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ccf33e",
  null
  
)

export default component.exports